import React from "react";
import Purchasetable from "../../components/dashboard/purchasetable";

const purchasetable = () => {
  return (
    <>
      <Purchasetable />
    </>
  );
};

export default purchasetable;
